<template>
  <a class="skip-link" href="#main">{{ labels.skip }}</a>
  <header class="mock-header" id="top">
    <nav class="mock-nav home-shell" :aria-label="labels.navLabel">
      <div class="mock-brand">
        <a :href="localizedPath('/')" class="mock-logo" :aria-label="labels.homeLabel">
          <img src="/images/logo/logo.svg" alt="Sharewell" width="154" height="57">
        </a>
        <p class="mock-tagline">
          {{ labels.tagline }}
        </p>
      </div>

      <div v-if="showMarketingLinks" class="mock-nav-links" :aria-label="labels.sectionsLabel">
        <a :href="localizedPath('/occasions')">{{ labels.occasions }}</a>
        <a :href="localizedPath('/#how-it-works')">{{ labels.how }}</a>
        <a :href="localizedPath('/#examples')">{{ labels.examples }}</a>
        <a :href="localizedPath('/pricing')">{{ labels.pricing }}</a>
        <a :href="localizedPath('/faq')">{{ labels.faq }}</a>
      </div>

      <div class="mock-account-area">
        <UserMenu
          variant="mock"
          :mobile-links="mobileLinks"
          :mobile-home-path="localizedPath('/')"
        />
      </div>
    </nav>
  </header>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { MARKETING_COPY } from '../../scripts/lib/marketing_chrome.mjs'
import UserMenu from './user_menu.vue'

export default {
  name: 'SharewellMarketingHeader',
  components: { UserMenu },
  setup() {
    const { locale } = useI18n()
    const route = useRoute()
    const activeLocale = computed(() => (MARKETING_COPY[locale.value] ? locale.value : 'en'))
    const labels = computed(() => MARKETING_COPY[activeLocale.value])
    const accountPaths = new Set(['/my-cards', '/account', '/admin'])
    const isAccountPath = computed(() => {
      if (accountPaths.has(route.path)) return true
      return route.path.startsWith('/admin/')
    })
    const isCardCreationPath = computed(() => route.path === '/card')
    const showMarketingLinks = computed(() => (
      !isAccountPath.value && !isCardCreationPath.value
    ))

    const localizedPath = (path) => {
      if (activeLocale.value === 'fr') {
        if (path === '/') return '/fr'
        if (path.startsWith('/#')) return `/fr${path.slice(1)}`
        return `/fr${path}`
      }
      if (activeLocale.value === 'es') {
        if (path === '/') return '/es'
        if (path.startsWith('/#')) return `/es${path.slice(1)}`
        return `/es${path}`
      }
      return path
    }

    const mobileLinks = computed(() => {
      if (!showMarketingLinks.value) return []
      return [
        { href: localizedPath('/occasions'), label: labels.value.occasions },
        { href: localizedPath('/#how-it-works'), label: labels.value.how },
        { href: localizedPath('/#examples'), label: labels.value.examples },
        { href: localizedPath('/pricing'), label: labels.value.pricing },
        { href: localizedPath('/faq'), label: labels.value.faq }
      ]
    })

    return {
      labels,
      localizedPath,
      showMarketingLinks,
      mobileLinks
    }
  }
}
</script>
